<template>
  <div class="select">
    <select
      v-validate="validateRules"
      :name="name"
      :value="value"
      :disabled="disabled"
      :class="{
        'input': true,
        'error': errors.has(name),
        'bolded': bolded
      }"
      @change="updateValue($event.target.value)"
    >
      <option
        v-for="option in options.data"
        :key="option.key"
        :value="option.key"
        :selected="option.key == value"
      >
        {{ option.key == options.default.key ? options.default.value : option.value }}
      </option>
    </select>
    <InputErrorBox
      v-show="errors.has(name)"
      :message="errors.first(name)"
    />
  </div>
</template>

<script>
import InputErrorBox from "./ds-input-error-box";

export default {
  name: "DsSelect",
  inject: ["$validator"],
  components: {
    InputErrorBox
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: String | Number,
      default: ""
    },
    options: {
      type: Object,
      default: () => {}
    },
    validateRules: {
      type: String | Object,
      default: ""
    },
    bolded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue: function(value) {
      console.log(value);
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.select {
  width: 100%;
  select {
    border-color: $border-color;
    width: 100%;
    height: $input-height;
    &:active,
    &:focus {
      border-color: $border-color;
      box-shadow: none;
    }
  }
  select[disabled] {
    background-color: $silver-dark-color;
    cursor: initial;
    &:hover {
      border: 1px solid $border-color;
    }
  }
  select.error {
    border: 1px solid $red-error-color;
  }
  select.bolded {
    font-weight: 500;
  }
  &::after {
    border: 2px solid #000 !important;
    border-right: 0 !important;
    border-top: 0px !important;
    font-size: 600;
  }
  span.error {
    color: $red-error-color;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-select.vue